import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const StatusTypeServiceConfig = {
  name: "StatusType",
  annotations: []
} as ServiceConfig;